import React, { useState } from 'react'
import { node, object } from 'prop-types'
import { useSpring, animated, config } from 'react-spring'
import { useMeasure } from 'react-use'
import { Box, FlexGrid } from '@telus-uds/components-web'

import { OverflowHidden } from './styles'
import BasicInfo from './BasicInfo'
import ActionBar from './ActionBar'
import OfferDetailsContainer from './OfferDetailsContainer'

const CartItem = ({ children, cartItem }) => {
  const [heightRef, { height }] = useMeasure()
  const [isDetailVisible, setIsDetailVisibility] = useState(false)
  const styles = useSpring({
    opacity: isDetailVisible ? 1 : 0,
    height: isDetailVisible ? height : 0,
    config: {
      ...config?.default,
      mass: 1
    }
  })
  const childrenArray = React.Children.toArray(children)
  const originalBasicInfo = childrenArray.find((c) => c.type.name === BasicInfo.name)
  const originalActionBar = childrenArray.find((c) => c.type.name === ActionBar.name)
  const offerDetails = childrenArray.find((c) => c.type.name === OfferDetailsContainer.name)

  const actionBar = React.cloneElement(originalActionBar, {
    isDetailVisible,
    cartItem,
    toggleOfferDetail: () => setIsDetailVisibility(!isDetailVisible)
  })
  const basicInfo = React.cloneElement(originalBasicInfo, {
    cartItem
  })
  return (
    <Box>
      <FlexGrid gutter={false}>
        <OverflowHidden data-testid="cart-item">
          {basicInfo}
          {actionBar}
          <animated.div style={styles} data-test-animation="true">
            <div ref={heightRef}>{offerDetails}</div>
          </animated.div>
        </OverflowHidden>
      </FlexGrid>
    </Box>
  )
}

export default CartItem

CartItem.propTypes = {
  children: node.isRequired,
  cartItem: object.isRequired
}
export { BasicInfo, ActionBar, OfferDetailsContainer }
